import styled from '@emotion/styled';

// Container

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  padding: 2rem;
`;
